import React, { useState, useEffect } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Image } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { Link, useParams, useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import BL1 from "../../assets/vd-1.svg";
import BL2 from "../../assets/vd-2.svg";
import BL3 from "../../assets/vd-3.svg";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.css";
import "froala-editor/js/plugins.pkgd.min.js";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import vname from "../../assets/vname.png";
import vlimit from "../../assets/vlimit.png";
import vvalue from "../../assets/vvalue.png";
import vprice from "../../assets/vprice.png";
import vdate from "../../assets/vdate.png";
import Preview from "../../assets/preview.svg";
import voud from "../../assets/vou-d.png";
import SideBar from "../SideBar/SideBar";
import { VoucherDetailsAPI } from "./../API/Vouchers/VoucherDetails";
import Loader from "../Loader/Loader";
import swal from "sweetalert";
import bannerBgImg from "../../assets/banner-detail.png";
import binfo from "../../assets/binfo.svg";
import NoDataText from "../NoDataText";
import { UpdateApi } from "../API/Vouchers/UpdateStatus";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import { FormatDateShortMonth } from "../../Utils/DateFormatter";

const VoucherDetails = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);

  const newBannerName =
    data?.business_name?.length > 35
      ? data?.business_name?.substring(0, 35) + "..."
      : data?.business_name;

  useEffect(() => {
    ApiLoad();
  }, []);

  const ApiLoad = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      voucher_id: parseInt(slug),
    };

    const coupondetailData = await VoucherDetailsAPI(data, () => {
      navigate("/");
    });
    // console.log(coupondetailData,"coupondetailData")
    if (coupondetailData.success == true) {
      setLoading(false);
      setdata(coupondetailData.data[0]);
    } else if (coupondetailData.status === 429) {
      setLoading(false);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    } else {
      setLoading(false);
      swal({
        text: `${coupondetailData.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
      swal.stopLoading();
      swal.close();
      navigate("/coupons/coupons-dashboard");
    }
  };

  // update status
  const handleChangeDropDown = (e, name) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      voucher_id: [parseInt(slug)],
      status_id: parseInt(e.target.value),
    };
    // const coupondetailData = UpdateStatus(data);
    swal({
      title: `Are you sure you want to update status of "${name}"?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const Response = await UpdateApi(data, () => {
          navigate("/");
        });
        if (Response.success == true) {
          swal({
            // title: "Success!",
            title: `"${name}" status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((isOk) => {
            if (isOk) {
              ApiLoad();
            }
          });
        } else {
          swal({
            text: "Please wait...",
            icon: "error",
            buttons: "Ok",
          });

          ApiLoad();
        }
      } else {
        setTimeout(() => {
          window.location.reload(false);
        }, 300);
        //ApiLoad()
      }
    });
    setLoading(false);
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Vouchers</p>
          <p className="text-right orange-text mx-2">
            <div className="orange-text">
              <Image src={binfo} className="mb-1"></Image>{" "}
              <b>{data.business_name}</b>
            </div>
          </p>
          <div
            className="my-3 inner-banner coupon_banner_img"
            style={{
              backgroundImage:
                data.business_banner != ""
                  ? `url(${data.business_banner})`
                  : `url(${bannerBgImg})`,
            }}
          >
            {/* <p className="banner-title">{newBannerName}</p> */}
          </div>
          <div>
            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen
              className="bl-accordian mt-5 VouDetAccord"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <Image src={BL1} className="bl-img"></Image> Voucher
                  Information
                </Accordion.Header>
                <Accordion.Body className="VouInfo">
                  <div className="d-flex">
                    <div className="mx-3">
                      <Image
                        src={
                          data.voucher_image == "" ? voud : data.voucher_image
                        }
                        className="VouInfoImage coupon_detail_img"
                      ></Image>
                    </div>
                    <Table className="accordian-table">
                      <tbody>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vname} className="bl-img mb-1"></Image>
                            Voucher Name
                          </td>
                          <td>{data.voucher_name}</td>
                        </tr>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vlimit} className="bl-img mb-1"></Image>
                            Voucher limit
                          </td>
                          <td>{data.voucher_limit}</td>
                        </tr>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vvalue} className="bl-img mb-1"></Image>
                            Voucher Value
                          </td>
                          <td>${data.voucher_value}</td>
                        </tr>
                        <tr>
                          <td width="300px" className="gi-lable">
                            <Image src={vprice} className="bl-img mb-1"></Image>
                            Voucher Price
                          </td>
                          <td>${data.voucher_price}</td>
                        </tr>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vdate} className="bl-img mb-1"></Image>
                            Voucher Publish Start Date
                          </td>
                          <td>{FormatDateShortMonth(data?.start_date)}</td>
                        </tr>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vdate} className="bl-img mb-1"></Image>
                            Voucher Available Until Date
                          </td>
                          <td>
                            {FormatDateShortMonth(
                              data?.voucher_avail_until_date
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="gi-lable">
                            <Image src={vdate} className="bl-img mb-1"></Image>
                            Voucher Expiration Date
                          </td>
                          <td>{FormatDateShortMonth(data?.end_date)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <Image src={BL2} className="bl-img"></Image> Voucher
                  Description
                </Accordion.Header>
                <Accordion.Body>
                  {data?.voucher_description?.length == 0 ? (
                    <p className="noData">{NoDataText.ErrText}</p>
                  ) : (
                    <FroalaEditorView model={data?.voucher_description} />
                  )}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <Image src={BL3} className="bl-img"></Image> Terms &
                  Conditions
                </Accordion.Header>
                <Accordion.Body>
                  <ul>
                    {data?.voucher_term_condition?.length == 0 ? (
                      <p className="noData">{NoDataText.ErrText}</p>
                    ) : (
                      <>
                        {data?.voucher_term_condition?.map((item, key) => {
                          return <li>{item}</li>;
                        })}
                      </>
                    )}
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <p className="width-150 m-auto">
              <Form.Select
                aria-label="Default select example"
                className="table-select status_select"
                onChange={(e) => handleChangeDropDown(e, data?.voucher_name)}
              >
                {data?.status_option?.map((i, k) => {
                  return (
                    <option
                      value={i.id}
                      selected={data.approval_status == i.id ? "selected" : ""}
                    >
                      {i.status}
                    </option>
                  );
                })}
              </Form.Select>
            </p>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default VoucherDetails;
